import { lazyOpenYammerPublisher } from 'owa-yammer-publisher';
import { logUsage } from 'owa-analytics';

export default function onNewYammerPost(): void {
    logUsage('YammerPublisher_NewPost');
    lazyOpenYammerPublisher.importAndExecute();
}
